import {useCallback, useContext, useEffect, useState} from "react";
import api from 'services/api';
import {FormataValor} from "functions/formatavalor"
import {getadmin, getcodCidade, getestabelecimentos} from "functions/gettabconfig";
import {formatDate, formatImage, getHoje} from "components/formatos";
import VENDASModal from './modal'
import SELECT from "components/select";
import config from "config";
import MESSAGE from "components/message";
import PAGINACAO from "components/paginacao";
import {CidadeContext} from "services/cidade";
import './style.css';


function VendaParceiro() {
    const [lvenda, setLVendas] = useState([]);
    const [operacao, setOperacao] = useState('')
    const [idcampanha, setIDCampanha] = useState(-1);
    const [dencampanha, setDenCampanha] = useState('');
    const [idestabelecimento, setIDEstabelecimento] = useState(getestabelecimentos(0));
    const [denestabelecimento, setDenEstabelecimento] = useState('');
    const [lparceiros, setLParceiros] = useState([]);
    const [lcampanha, setLCampanha] = useState([]);
    const [search, setSearch] = useState('');
    const [foto, setFoto] = useState('');
    const [mensagem, setMensagem] = useState('');
    // necessario para usar cidade global para admin e cidada do login para parceiro
    const { cod_cidade } = useContext(CidadeContext);
    const codcidade = getadmin() ? cod_cidade : getcodCidade();
    const [resetPage, setResetPage] = useState(false);

    // Modal
    const [dados, setDados] = useState([]);
    const [isOpen, setIsOpen] = useState(false);

    function novaVenda() {
        setDados({
            'id_venda': 0,
            'id_campanha': idcampanha,
            'den_campanha': dencampanha,
            'id_estabelecimento': idestabelecimento,
            'nome_estabelecimento': denestabelecimento,
            'id_usuario': -1,
            'dat_venda': getHoje(),
            'valor_venda': 0.00,
            'numero_venda': '',
            'nomeusuarios': ''
        });
        setIsOpen(true);
    }

    function editarVenda(linha) {
        api.get(`${config.PARCEIRO_VENDAS}/${linha.id_estabelecimento}/${linha.id_venda}`)
            .then(response => {
                setOperacao('UPDATE')
                setDados(response.data[0]);
                setIsOpen(true);
            }).catch(err => {
                console.log(err)
                setMensagem(err);
            })
    }

    function closeVENDASModal() {
        setIsOpen(false);
        BuscarExtrato();
    }

    const BuscaCampanha = useCallback(() => {
        api.get(`${config.CAMPANHAS}?codcidade=${codcidade}`)
            .then(response => {
                if (response.status === 200) {
                    setLCampanha(response.data);
                    setIDCampanha(response.data[0].id_campanha);
                    setDenCampanha(response.data[0].den_campanha);
                } else {
                    setMensagem('Não carregou as campanhas');
                }
            });
    }, [codcidade]);

    const BuscarExtrato = useCallback(() => {
        if (idestabelecimento > 0 && idcampanha > 0) {
            api.get(`${config.PARCEIRO_VENDAS}?id_campanha=${idcampanha}&id_estabelecimento=${idestabelecimento}`)
                .then(response => {
                    if (response.status === 200) {
                        setLVendas(response.data);
                    }
                });
        }
    }, [idestabelecimento, idcampanha]);

    const BuscaEstabelecimento = useCallback(() => {
        if (idestabelecimento > 0) {
            api.get(`${config.ADM_ESTABELECIMENTOS}/${idestabelecimento}`)
                .then(response => {
                    if (response.status === 200) {
                        setDenEstabelecimento(response.data[0].nome);
                        setFoto(response.data[0].url_logo);
                        if (response.data[0].campanhas.length === 0) {
                            setMensagem('Estabelecimento não participa da campanha');
                            console.log('1-Estabelecimento não participa da campanha')
                            setLCampanha([]);
                        } else {
                            setLCampanha(response.data[0].campanhas);
                            if (response.data[0].campanhas.length > 0) {
                                // Só atualiza a campanha se ainda não estiver setada ou se não estiver na lista
                                const campanhaExiste = response.data[0].campanhas.find(c => c.id_campanha === idcampanha);
                                if (idcampanha === -1 || !campanhaExiste) {
                                    setIDCampanha(response.data[0].campanhas[0].id_campanha);
                                    setDenCampanha(response.data[0].campanhas[0].den_campanha);
                                }
                            }
                        }
                    } else {
                        setMensagem('Estabelecimento não encontrado');
                        console.log('2-Estabelecimento não encontrado');
                        setLCampanha([]);
                    }
                }).catch(err => {
                    console.log('Erro ao buscar estabelecimento:', err);
                    setMensagem('Erro ao buscar dados do estabelecimento');
                });
        }
    }, [idestabelecimento, idcampanha]);

    useEffect(() => {
        if (resetPage) {
            setResetPage(false);
        }
    }, [resetPage]);

    useEffect(() => {
        BuscarExtrato();
    }, [idcampanha, BuscarExtrato]);

    useEffect(() => {        
        api.get(`${config.ADM_ESTABELECIMENTOS}?codcidade=${codcidade}`)
            .then(response => {
                if (response.status === 200) {
                    setLParceiros(response.data);
                    const idEstabInicial = getestabelecimentos(0);
                    setIDEstabelecimento(idEstabInicial);
                }
            })
        BuscaCampanha();
    }, [codcidade, BuscaCampanha]);

    useEffect(() => {
        if (idestabelecimento > 0) {
            BuscaEstabelecimento();
        }
    }, [idestabelecimento, BuscaEstabelecimento])


    function salvaCampanha(e) {
        const id = parseInt(e.target.value, 10);
        setIDCampanha(id);
        const lden = lcampanha.filter(f => f.id_campanha === id);
        lden.length > 0 && setDenCampanha(lden[0].den_campanha);
    }

    function setNovoEstabelecimento(e) {
        const id = parseInt(e.target.value, 10);
        setIDEstabelecimento(id);
        const lden = lparceiros.filter(f => f.id_estabelecimento === id);
        lden.length > 0 && setDenEstabelecimento(lden[0].nome);
    }

    function KeyDown(e) {
        if (e.key === "Enter") {
            e.preventDefault();
            searchLancamento();
        }
    }

    async function searchLancamento() {
        try {
            const response = await api.get(`${config.PARCEIRO_VENDAS}?id_campanha=${idcampanha}&id_estabelecimento=${idestabelecimento}`);
            const listaall = response.data;

            const lista = listaall.filter(venda => {
                const matchNumeroVenda = venda.numero_venda.includes(search);
                const matchNomeUsuarios = venda.nomeusuarios.toLowerCase().includes(search.toLowerCase());
                return matchNumeroVenda || matchNomeUsuarios;  // Considera correspondência em um ou outro campo
            });
            setLVendas(lista);
            setResetPage(true);
        } catch (error) {
            console.error("Erro ao buscar dados:", error);
        }
    }

    return (
        <div>
            <VENDASModal isOpen={isOpen}
                onRequestClose={closeVENDASModal}
                operacao={operacao}
                dados={dados}
            />
            
            <div className="admin-header-section mb-4">
                <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 mb-4">
                    <h2 className="section-title mb-0">
                        {getadmin() ? 'Gestão de Vendas' : `Vendas: ${denestabelecimento}`}
                    </h2>
                    <div className="d-flex gap-2">
                        <button 
                            className="btn btn-primary d-flex align-items-center gap-2 px-4 py-2 shadow-sm" 
                            onClick={() => novaVenda()}
                            style={{ borderRadius: '12px' }}
                        >
                            <i className="fas fa-plus"></i>
                            <span>Lançar Venda</span>
                        </button>
                        <button 
                            className="btn btn-outline-secondary d-flex align-items-center justify-content-center p-2 shadow-sm" 
                            onClick={() => BuscarExtrato()}
                            style={{ borderRadius: '12px', width: '42px' }}
                            title="Atualizar Lista"
                        >
                            <i className="fas fa-sync"></i>
                        </button>
                    </div>
                </div>

                <MESSAGE msg={mensagem} />

                <div className="modern-filter-bar p-4 bg-card-admin rounded-4 mb-4">
                    <div className="row g-3">
                        <div className="col-12 col-md-2 d-flex justify-content-center align-items-center">
                            <div className="parceiro-logo-preview p-2 border rounded-circle bg-white shadow-sm" style={{ width: '80px', height: '80px' }}>
                                {formatImage(foto) ? <img src={formatImage(foto)} alt="Logo" className="w-100 h-100 object-fit-contain rounded-circle" /> : <i className="fas fa-store text-muted opacity-25 fa-2x"></i>}
                            </div>
                        </div>
                        
                        {getadmin() && (
                            <div className="col-12 col-md-5">
                                <label className="form-label fw-bold text-muted small text-uppercase">Estabelecimento</label>
                                <SELECT
                                    key={'SELECTPARCEIRO'}
                                    name={'SELECTPARCEIRO'}
                                    SalvaSelect={setNovoEstabelecimento}
                                    value={idestabelecimento}
                                    chave={'id_estabelecimento'}
                                    descricao={'nome'}
                                    aoptions={lparceiros}
                                    retornoe={true}
                                />
                            </div>
                        )}
                        
                        <div className={`col-12 ${getadmin() ? 'col-md-5' : 'col-md-10'}`}>
                            <label className="form-label fw-bold text-muted small text-uppercase">Campanha Ativa</label>
                            <SELECT
                                key={'0001'}
                                name={'SELECTCAMPANHA'}
                                SalvaSelect={salvaCampanha}
                                value={idcampanha}
                                chave={'id_campanha'}
                                descricao={'den_campanha'}
                                aoptions={lcampanha}
                                retornoe={true}
                            />
                        </div>

                        <div className="col-12 mt-3">
                            <div className="input-group modern-search-input">
                                <span className="input-group-text bg-transparent border-end-0 text-muted ps-3">
                                    <i className="fas fa-search"></i>
                                </span>
                                <input 
                                    type="search"
                                    className="form-control border-start-0 ps-0 py-2 shadow-none"
                                    placeholder="Buscar por número da venda ou nome do cliente..."
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                    onKeyDown={KeyDown}
                                />
                                <button 
                                    className="btn btn-primary px-4"
                                    onClick={() => searchLancamento()}
                                >
                                    Pesquisar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <PAGINACAO
                resetPage={resetPage}
                data={lvenda}
                itemsPerPage={12}
                renderItems={(currentItems) => (
                    <div className="row g-4">
                        {currentItems.map((e, index) => (
                            <div className="col-12 col-md-6 col-lg-4 col-xl-3" key={`venda-${index}`}>
                                <div className="venda-admin-card h-100 bg-card-admin rounded-4 overflow-hidden position-relative transition-all" onClick={() => editarVenda(e)}>
                                    <div className="p-3 border-bottom d-flex align-items-center justify-content-between bg-light-subtle">
                                        <span className="text-muted small fw-bold">#{e.numero_venda}</span>
                                        <span className="text-primary fw-bold">
                                            R$ {FormataValor(e.valor_venda, 'NUMEROD2')}
                                        </span>
                                    </div>
                                    
                                    <div className="p-4">
                                        <div className="d-flex align-items-center gap-3 mb-3">
                                            <div className="cliente-avatar-mini bg-light text-primary rounded-circle d-flex align-items-center justify-content-center fw-bold" style={{ width: '40px', height: '40px' }}>
                                                {e.nomeusuarios ? e.nomeusuarios.charAt(0).toUpperCase() : 'U'}
                                            </div>
                                            <div className="overflow-hidden">
                                                <div className="text-muted small" style={{fontSize: '0.65rem', textTransform: 'uppercase'}}>Cliente</div>
                                                <div className="fw-bold text-dark text-truncate" title={e.nomeusuarios}>
                                                    {e.nomeusuarios}
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div className="d-flex align-items-center text-muted small">
                                            <i className="far fa-calendar-alt me-2 text-primary"></i>
                                            <span>Realizada em: <strong>{formatDate(e.dat_venda)}</strong></span>
                                        </div>
                                    </div>
                                    
                                    <div className="p-3 border-top bg-light-subtle d-flex justify-content-center">
                                        <button className="btn btn-outline-primary btn-sm rounded-3 px-4 w-100">
                                            <i className="fas fa-edit me-1"></i> Detalhes da Venda
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            />
        </div>
    );

}
export default VendaParceiro;